/* ------------------------------------------------------------------
   Warenkorb-Werkzeuge fuer alle eigenen Bausteine
   (Zubehoer-Karte, Kombi-Vorschlag, Bundle-Hinweis, USB-Stick).

   WARUM ES DIESE DATEI GIBT
   -------------------------
   Vorher schickte jeder Baustein selbst ein POST an /cart/add.js und
   loeste danach `cart:update` und `cart:refresh` aus. Beides kennt
   Canyon nicht. Ergebnis: der Artikel lag im Warenkorb, aber die Zahl
   am Warenkorbsymbol und der Inhalt der Schublade blieben stehen, bis
   der Besucher die Seite neu lud. Genau das war die Beschwerde.

   Nachgemessen am 30.08. im Theme:
     * Canyon horcht auf `shopify:cart:lines-update` - dieses Ereignis
       allein aktualisiert die Anzeige aber NICHT.
     * Der eigene Kaufknopf des Themes benutzt die Section Rendering
       API: er schickt `sections` mit und tauscht das zurueckgelieferte
       HTML aus. Erst das bringt Zaehler und Schublade auf Stand.

   Nachgemessen am 31.08.: /cart/add.js und /cart/change.js liefern auf
   diesem Shop `sections: null` zurueck - mit und ohne Abfrageteil in
   `sections_url`. Der zweite Weg, GET /?sections=..., funktioniert
   einwandfrei. Deshalb wird beides versucht (siehe `nachbereiten`).

   WELCHE ABSCHNITTE getauscht werden, wird NICHT fest eingetragen,
   sondern bei jedem Aufruf gesucht: jeder `#shopify-section-*`, in dem
   ein `cart-icon`, `cart-drawer-component` oder `cart-items-component`
   steckt. Damit ueberlebt der Code eine Umbenennung im Theme.

   NEBENWIRKUNG, die geprueft wurde: beim Tausch des Kopfbereichs
   verschwindet der per Skript eingehaengte Sprachumschalter kurz.
   `bsfa-sprachen.liquid` beobachtet den Baum und haengt ihn sofort
   wieder ein. Bitte diesen Beobachter nicht entfernen.

   Ohne fetch (sehr alte Browser) passiert hier nichts.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  function wurzelPfad() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function hatFetch() {
    return typeof window.fetch === 'function';
  }

  /* Auf der passwortgeschuetzten Entwurfsfassung haengen _fd/_ab/_sc in
     der Adresse. Ohne sie landet ein Abruf auf der Passwortseite. */
  function mitParametern(pfad) {
    var s = window.location.search;
    if (!s) return pfad;
    return pfad + (pfad.indexOf('?') === -1 ? s : '&' + s.slice(1));
  }

  /* Alle Abschnitte, die den Warenkorb zeigen.

     `.ol-wk` ist die eigene Warenkorbseite (sections/ol-korb.liquid),
     `.ol-dst` der Block mit den Zusatzleistungen. Beide enthalten keines
     der Canyon-Elemente und blieben deshalb nach einer Aenderung stehen -
     auf /cart sah man die alte Menge, bis die Seite neu geladen wurde. */
  function warenkorbAbschnitte() {
    var ids = [];
    var kandidaten = document.querySelectorAll('[id^="shopify-section-"]');
    for (var i = 0; i < kandidaten.length; i++) {
      if (kandidaten[i].querySelector('cart-icon, cart-drawer-component, cart-items-component, .ol-dst, .ol-wk')) {
        ids.push(kandidaten[i].id.replace('shopify-section-', ''));
      }
    }
    return ids;
  }

  /* Zurueckgeliefertes HTML an die Stelle des alten Abschnitts setzen. */
  function abschnitteTauschen(abschnitte) {
    if (!abschnitte) return;
    Object.keys(abschnitte).forEach(function (schluessel) {
      var alt = document.getElementById('shopify-section-' + schluessel);
      var html = abschnitte[schluessel];
      if (!alt || !html) return;
      var behaelter = document.createElement('div');
      behaelter.innerHTML = String(html).trim();
      var neu = behaelter.firstElementChild;
      for (var i = 0; i < behaelter.children.length; i++) {
        if (behaelter.children[i].id === alt.id) { neu = behaelter.children[i]; break; }
      }
      if (!neu) return;
      /* r19a-teile (11.10.): nicht den ganzen Abschnitt tauschen, wenn darin das
         Schubfach oder der Kopf steckt. Das ersetzte vorher das OFFENE Schubfach
         samt <dialog>: es schloss sich, die Seite blieb gesperrt und dunkel, und
         der Kopf verlor seine gemessene Menueaufteilung. Jetzt: im Schubfach nur
         <cart-drawer-component> (der Dialog bleibt offen), im Kopf nur <cart-icon>. */
      var a1 = alt.querySelectorAll('cart-drawer-component'), n1 = neu.querySelectorAll('cart-drawer-component');
      if (a1.length && a1.length === n1.length) { for (var j = 0; j < a1.length; j++) a1[j].replaceWith(n1[j]); return; }
      var nurKopf = !alt.querySelector('.ol-wk, .ol-dst, cart-items-component');
      var a2 = alt.querySelectorAll('cart-icon'), n2 = neu.querySelectorAll('cart-icon');
      if (nurKopf && a2.length && a2.length === n2.length) { for (var k = 0; k < a2.length; k++) a2[k].replaceWith(n2[k]); return; }
      alt.replaceWith(neu);
    });
  }

  function melden() {
    document.dispatchEvent(new CustomEvent('shopify:cart:lines-update', {
      bubbles: true,
      detail: { source: 'officelicense24' }
    }));
  }

  function nachbereiten(daten) {
    var mitgeliefert = daten && daten.sections && Object.keys(daten.sections).length > 0;
    if (mitgeliefert) {
      abschnitteTauschen(daten.sections);
      melden();
      return Promise.resolve(daten);
    }
    return window.olWarenkorb.auffrischen().then(function () {
      melden();
      return daten;
    });
  }

  function schreiben(pfad, nutzlast) {
    var abschnitte = warenkorbAbschnitte();
    if (abschnitte.length) {
      nutzlast.sections = abschnitte.join(',');
      nutzlast.sections_url = window.location.pathname + window.location.search;
    }
    return fetch(wurzelPfad() + pfad, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(nutzlast)
    }).then(function (antwort) {
      if (!antwort.ok) throw new Error('abgelehnt');
      return antwort.json();
    });
  }

  /* ================================================================
     Oeffentliche Schnittstelle
     ================================================================ */
  window.olWarenkorb = {
    /* hinzufuegen(varianteId, menge, eigenschaften) -> Promise
       `eigenschaften` landet als `properties` an der Warenkorbzeile.
       Namen mit fuehrendem Unterstrich zeigt Shopify dem Kunden nicht
       an - genau richtig fuer die Kopplung des USB-Sticks. */
    hinzufuegen: function (varianteId, menge, eigenschaften) {
      if (!hatFetch()) return Promise.reject(new Error('kein fetch'));
      var eintrag = { id: Number(varianteId), quantity: Number(menge) || 1 };
      if (eigenschaften) eintrag.properties = eigenschaften;
      return schreiben('cart/add.js', { items: [eintrag] }).then(nachbereiten);
    },

    /* Den aktuellen Warenkorb lesen. */
    holen: function () {
      if (!hatFetch()) return Promise.reject(new Error('kein fetch'));
      return fetch(mitParametern(wurzelPfad() + 'cart.js'), {
        headers: { Accept: 'application/json' }
      }).then(function (a) {
        if (!a.ok) throw new Error('abgelehnt');
        return a.json();
      });
    },

    /* Eine Zeile aendern. `schluessel` ist der Zeilenschluessel aus
       /cart.js (nicht die Varianten-Nummer): nur er trifft sicher die
       richtige Zeile, wenn dieselbe Variante mit unterschiedlichen
       Eigenschaften mehrfach im Korb liegt. */
    setzen: function (schluessel, menge) {
      if (!hatFetch()) return Promise.reject(new Error('kein fetch'));
      return schreiben('cart/change.js', { id: String(schluessel), quantity: Number(menge) || 0 })
        .then(nachbereiten);
    },

    /* Bequemer Weg ueber die Varianten-Nummer: erst die Zeile suchen,
       dann ueber ihren Schluessel entfernen. */
    entfernen: function (varianteId) {
      var ziel = String(varianteId);
      return this.holen().then(function (korb) {
        var zeile = null;
        (korb.items || []).forEach(function (z) {
          if (String(z.variant_id) === ziel && !zeile) zeile = z;
        });
        if (!zeile) return null;
        return window.olWarenkorb.setzen(zeile.key, 0);
      });
    },

    /* Nur die Anzeige auffrischen, ohne etwas zu aendern. */
    auffrischen: function () {
      var abschnitte = warenkorbAbschnitte();
      if (!abschnitte.length || !hatFetch()) return Promise.resolve();
      var url = mitParametern(wurzelPfad()) ;
      url += (url.indexOf('?') === -1 ? '?' : '&') + 'sections=' + encodeURIComponent(abschnitte.join(','));
      return fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (a) { return a.ok ? a.json() : null; })
        .then(abschnitteTauschen)
        .catch(function () { /* stillschweigend: die Seite bleibt nutzbar */ });
    }
  };

  /* ================================================================
     USB-WAECHTER

     REGEL, die der Shop-Inhaber vorgegeben hat:
     Der USB-Stick ist Zubehoer zu einer Office-Lizenz. Er darf NIE
     allein im Warenkorb liegen, und wenn die zugehoerige Lizenz
     herausgenommen wird, muss er mitgehen.

     WIE DIE KOPPLUNG FESTGEHALTEN WIRD
     ----------------------------------
     Beim Hinzufuegen bekommt die Stick-Zeile die versteckte
     Eigenschaft `_lizenz` mit der Varianten-Nummer der Lizenz, zu der
     er gehoert. Der Waechter prueft dann nur noch:

       1. Gibt es eine Warenkorbzeile mit dieser Varianten-Nummer?
          Nein -> Stick raus.
       2. Ist die Menge des Sticks groesser als die der Lizenz?
          Ja -> auf die Menge der Lizenz heruntersetzen.
       3. Liegt eine Stick-Zeile OHNE `_lizenz` im Korb (jemand hat die
          Adresse /cart/add?id=... von Hand aufgerufen)?
          -> raus.

     Ueber die Varianten-Nummer statt ueber Produkttyp oder Handle zu
     gehen ist Absicht: Namen und Schlagworte lassen sich im Admin
     aendern, die Nummer der Zeile nicht faelschen.

     GRENZE, die ehrlich benannt sei: das hier laeuft im Browser. Wer
     die Kasse direkt aufruft, ohne je eine Seite des Shops zu laden,
     wird davon nicht erwischt. Das liesse sich nur mit einer
     Shopify-Funktion (eigene App) endgueltig schliessen.
     ================================================================ */
  var USB = window.olUsbVariante ? String(window.olUsbVariante) : '';

  /* ----------------------------------------------------------------
     Zusatzleistungen (Fernwartung) haengen an einer Office-Lizenz.
     Liegt keine mehr im Korb, muessen sie mit heraus - sonst bezahlt
     jemand eine Installation fuer eine Software, die er nicht kauft.

     Erkannt wird an der Artikelnummer (OL-FW-30 / OL-FW-45) und am
     Produkttyp, nicht am Titel: Titel sind uebersetzt, die Nummer und
     der Typ nicht. 'Preisvergleich' sind die noindex-Doppelgaenger, in
     denen auch Windows liegt - deshalb dort zusaetzlich der Handle.
     ---------------------------------------------------------------- */
  function istDienst(zeile) {
    return typeof zeile.sku === 'string' && zeile.sku.indexOf('OL-FW-') === 0;
  }

  function istOffice(zeile) {
    var macOnlyProductIds = ["15947680416075", "15966111891787", "16064819724619", "16069557420363", "16069557649739", "16069557879115"];
    var handle = String(zeile.handle || '').toLowerCase();
    if (macOnlyProductIds.indexOf(String(zeile.product_id)) !== -1 || /(^|-)macs?($|-)/.test(handle)) return false;
    var art = zeile.product_type || '';
    if (art === 'Microsoft Office') return true;
    if (art === 'Preisvergleich' && String(zeile.handle || '').indexOf('office') !== -1) return true;
    return false;
  }

  /* Der Schluessel-Schutz haengt an irgendeiner Lizenz, nicht nur an
     Office - er wird deshalb erst entfernt, wenn gar keine mehr da ist. */
  function istSchutz(zeile) {
    return typeof zeile.sku === 'string' && zeile.sku.indexOf('OL-SW-') === 0;
  }

  function istLizenz(zeile) {
    var art = zeile.product_type || '';
    return art === 'Microsoft Office' || art === 'Windows' || art === 'Windows Server' || art === 'Preisvergleich';
  }

  function istStick(zeile) {
    if (USB && String(zeile.variant_id) === USB) return true;
    /* Zweiter Anhaltspunkt, falls die Nummer einmal nicht gesetzt ist:
       nur der Stick traegt diese Eigenschaft. */
    return !!(zeile.properties && zeile.properties._lizenz);
  }

  function aufraeumen(korb) {
    var zeilen = (korb && korb.items) || [];
    var mengeJeVariante = {};
    zeilen.forEach(function (z) {
      var k = String(z.variant_id);
      mengeJeVariante[k] = (mengeJeVariante[k] || 0) + z.quantity;
    });

    var aufgaben = [];
    zeilen.forEach(function (z) {
      if (!istStick(z)) return;
      var lizenz = z.properties && z.properties._lizenz ? String(z.properties._lizenz) : '';
      var vorhanden = lizenz ? (mengeJeVariante[lizenz] || 0) : 0;

      if (!vorhanden) {
        aufgaben.push({ schluessel: z.key, menge: 0, grund: 'ohne-lizenz' });
      } else if (z.quantity > vorhanden) {
        aufgaben.push({ schluessel: z.key, menge: vorhanden, grund: 'zu-viele' });
      }
    });

    /* Kein Office mehr im Korb -> jede gebuchte Fernwartung raus. */
    var hatOffice = false;
    zeilen.forEach(function (z) { if (istOffice(z)) hatOffice = true; });
    if (!hatOffice) {
      zeilen.forEach(function (z) {
        if (istDienst(z)) aufgaben.push({ schluessel: z.key, menge: 0, grund: 'ohne-office' });
      });
    }

    /* Keine Lizenz mehr im Korb -> auch der Schluessel-Schutz raus. */
    var hatLizenz = false;
    zeilen.forEach(function (z) { if (istLizenz(z)) hatLizenz = true; });
    if (!hatLizenz) {
      zeilen.forEach(function (z) {
        if (istSchutz(z)) aufgaben.push({ schluessel: z.key, menge: 0, grund: 'ohne-lizenz-schutz' });
      });
    }

    return aufgaben;
  }

  var laeuftGerade = false;

  function pruefen() {
    if (laeuftGerade || !hatFetch()) return Promise.resolve();
    laeuftGerade = true;
    return window.olWarenkorb.holen()
      .then(function (korb) {
        var aufgaben = aufraeumen(korb);
        if (!aufgaben.length) return null;
        /* Nacheinander, nicht parallel: jede Aenderung verschiebt die
           Zeilenschluessel der folgenden nicht, aber Shopify nimmt
           gleichzeitige Aenderungen am selben Korb uebel. */
        var kette = Promise.resolve();
        aufgaben.forEach(function (a) {
          kette = kette.then(function () { return window.olWarenkorb.setzen(a.schluessel, a.menge); });
        });
        return kette.then(function () { hinweisZeigen(aufgaben[0].grund); });
      })
      .catch(function () { /* stillschweigend */ })
      .then(function () { laeuftGerade = false; });
  }

  /* Kurzer Hinweis, damit niemand raetselt, warum der Stick weg ist. */
  function hinweisZeigen(grund) {
    var texte = (window.olUsbTexte || {});
    var text = grund === 'zu-viele' ? texte.zuViele : texte.ohneLizenz;
    if (!text) return;
    var alt = document.querySelector('.ol-usb-hinweis');
    if (alt) alt.remove();
    var kasten = document.createElement('div');
    kasten.className = 'ol-usb-hinweis';
    kasten.setAttribute('role', 'status');
    kasten.textContent = text;
    document.body.appendChild(kasten);
    setTimeout(function () { kasten.classList.add('ol-usb-hinweis--weg'); }, 6000);
    setTimeout(function () { if (kasten.parentNode) kasten.remove(); }, 6600);
  }

  window.olUsbWaechter = { pruefen: pruefen };

  /* Wann geprueft wird:
     - einmal beim Laden jeder Seite,
     - nach jeder Warenkorbaenderung, die das Theme oder wir melden,
     - auf der Warenkorbseite zusaetzlich kurz nach jedem Klick in der
       Artikelliste (dort sitzen Mengenknoepfe und Papierkorb, und
       Canyon meldet deren Wirkung nicht zuverlaessig). */
  function starten() {
    pruefen();

    var letzte = 0;
    document.addEventListener('shopify:cart:lines-update', function (e) {
      if (e && e.detail && e.detail.source === 'officelicense24-waechter') return;
      var jetzt = Date.now();
      if (jetzt - letzte < 400) return;
      letzte = jetzt;
      setTimeout(pruefen, 250);
    });

    document.addEventListener('click', function (e) {
      var innen = e.target && e.target.closest
        ? e.target.closest('cart-items-component, cart-drawer-component, '
                         + '#shopify-section-cart-drawer-section, .ol-wk')
        : null;
      if (!innen) return;
      setTimeout(pruefen, 700);
    }, true);

    /* Und in jedem Fall unmittelbar vor der Kasse. Dort entscheidet
       sich, was bezahlt wird - eine Stick-Menge, die groesser ist als
       die Zahl der Lizenzen, darf es hier nicht mehr geben. */
    document.addEventListener('click', function (e) {
      var kasse = e.target && e.target.closest
        ? e.target.closest('button[name="checkout"], input[name="checkout"], #checkout')
        : null;
      if (kasse) pruefen();
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten, { once: true });
  } else {
    starten();
  }
})();

